import _classCallCheck from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits"; //@ts-check

import React from 'react';
import cx from 'classnames';
import Icon from '../Icon';
/**
 * @extends {React.Component<import('./types').TreeNode>}
 */

var TreeNode =
/*#__PURE__*/
function (_React$Component) {
  _inherits(TreeNode, _React$Component);

  function TreeNode(props) {
    var _this;

    _classCallCheck(this, TreeNode);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TreeNode).call(this, props));

    _this.stopEventPropagation = function (e) {
      return e.stopPropagation();
    };

    _this.handleCollapse = function (e) {
      e.stopPropagation();
      var nodeId = _this.props.index.id;
      if (_this.props.onCollapse) _this.props.onCollapse(nodeId);
    };

    _this.handleMouseDown = function (e) {
      var nodeId = _this.props.index.id;
      var dom = _this.innerRef.current;
      if (_this.props.onDragStart) _this.props.onDragStart(nodeId, dom, e);
    };

    _this.renderCollapse = function () {
      var index = _this.props.index;

      if (index.children && index.children.length) {
        var collapsed = index.node.collapsed;
        return React.createElement("span", {
          className: cx('collapse'),
          onMouseDown: _this.stopEventPropagation,
          onClick: _this.handleCollapse
        }, React.createElement(Icon, {
          type: "".concat(collapsed ? 'menu-right' : 'menu-down-rotate'),
          className: "collapse-button"
        }));
      }

      return null;
    };

    _this.renderChildren = function () {
      var _this$props = _this.props,
          index = _this$props.index,
          tree = _this$props.tree,
          dragging = _this$props.dragging;

      if (index.children && index.children.length) {
        var childrenStyles = {
          paddingLeft: _this.props.paddingLeft
        };
        return React.createElement("div", {
          className: "children",
          style: childrenStyles
        }, index.children.map(function (child) {
          var childIndex = tree.getIndex(child);
          return React.createElement(TreeNode, {
            tree: tree,
            index: childIndex,
            key: childIndex.id,
            dragging: dragging,
            paddingLeft: _this.props.paddingLeft,
            onCollapse: _this.props.onCollapse,
            onDragStart: _this.props.onDragStart
          });
        }));
      }

      return null;
    };

    _this.innerRef = React.createRef();
    return _this;
  }

  _createClass(TreeNode, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          tree = _this$props2.tree,
          index = _this$props2.index,
          dragging = _this$props2.dragging;
      var node = index.node;
      var styles = {};
      return React.createElement("div", {
        className: cx('m-node', {
          placeholder: index.id === dragging
        }),
        style: styles
      }, React.createElement("div", {
        className: "inner",
        ref: this.innerRef,
        onMouseDown: this.handleMouseDown
      }, this.renderCollapse(), tree.renderNode(node)), node.collapsed ? null : this.renderChildren());
    }
  }]);

  return TreeNode;
}(React.Component);

export default TreeNode;